import * as React from 'react';
import styled from 'styled-components';

import { colors } from '../styles/variables';
import t from './locales';

const CouponTriggerView = styled.a`
  padding: 8px;
  font-size: 0.8em;
  color: ${colors.blue};
  &:hover {
    color: ${colors.blue};
  }
`;

// サーバーサイドでレンダリングされた Bootstrap Modal に依存します。
// クーポンが選択されるとパラメータ付きでリロードされます。
// 決済画面で行うとリロードによって注文内容がリセットされてしまうので、
// 決済の手前、カート画面で行うのがベター。

const CouponTrigger = ({ isSelected }: { isSelected: boolean }) => {
  return (
    <CouponTriggerView href="#" data-toggle="modal" data-target="#modal-coupon">
      {isSelected ? t.changeCoupon() : t.useCoupon()}
    </CouponTriggerView>
  );
}

export default CouponTrigger;
